const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Warnings/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Warnings/Search')

export default [
  {
    path: 'warnings/create',
    name: 'WarningsCreate',
    component: Single,
    meta: {
      title: 'Adicionar Suspensão / Advertência',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'warnings',
        action: 'create'
      }
    }
  },
  {
    path: 'warnings/:id',
    name: 'WarningsEdit',
    component: Single,
    meta: {
      title: 'Editar Suspensão / Advertência',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'warnings',
        action: 'read'
      }
    }
  },
  {
    path: 'warnings',
    name: 'WarningsSearch',
    component: Search,
    meta: {
      title: 'Suspensões / Advertências',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'warnings',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/warnings.js